import { render, staticRenderFns } from "./RightSiderBar.vue?vue&type=template&id=6cc7adcf&scoped=true"
import script from "./RightSiderBar.vue?vue&type=script&lang=js"
export * from "./RightSiderBar.vue?vue&type=script&lang=js"
import style0 from "./RightSiderBar.vue?vue&type=style&index=0&id=6cc7adcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7adcf",
  null
  
)

export default component.exports